import { render, staticRenderFns } from "./pic&video.vue?vue&type=template&id=8bc68c2e&scoped=true&"
import script from "./pic&video.vue?vue&type=script&lang=js&"
export * from "./pic&video.vue?vue&type=script&lang=js&"
import style0 from "./pic&video.vue?vue&type=style&index=0&id=8bc68c2e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc68c2e",
  null
  
)

export default component.exports